import {noop} from 'lodash';
import {createContext, useContext} from 'react';

import {globalNamespace} from '../../../../../../libs/shared/core/src/models/helpers/namespaceHelpers';
import {TrackDataEvent} from '../../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';

export type OnJumpToItem = ({activityId, itemType}: {activityId: number; itemType: string}) => void;

export interface SynopsisViewerContextProps {
  namespace: string;
  isInPopup: boolean;
  isFeedbackOpen: boolean;
  onFeedbackAction: (metadata: Record<string, unknown>) => void;
  onCloseFeedback: () => void;
  onSubmitFeedback: (feedback: string) => void;
  onJumpToItem: OnJumpToItem;
  onUnpinActivity: (activityId: number) => void;
  onTrackDataEvent: TrackDataEvent;
  setCopyText: (text: string) => void;
}

export const SynopsisViewerContext = createContext<SynopsisViewerContextProps>({
  namespace: globalNamespace,
  isInPopup: false,
  isFeedbackOpen: false,
  onFeedbackAction: noop,
  onCloseFeedback: noop,
  onSubmitFeedback: noop,
  onJumpToItem: noop,
  onUnpinActivity: noop,
  onTrackDataEvent: noop,
  setCopyText: noop,
});

export function useSynopsisViewerContext() {
  return useContext(SynopsisViewerContext);
}
